const TEST_SIGNUP_WEBHOOK_URL = 'https://hannahgraham.app.n8n.cloud/webhook-test/new-signup';
const PRODUCTION_SIGNUP_WEBHOOK_URL = 'https://hannahgraham.app.n8n.cloud/webhook/new-signup';

const SIGNUP_WEBHOOK_URL =
  import.meta.env.VITE_N8N_SIGNUP_WEBHOOK_URL ||
  (import.meta.env.DEV ? TEST_SIGNUP_WEBHOOK_URL : PRODUCTION_SIGNUP_WEBHOOK_URL);

export interface SignupWebhookPayload {
  userId?: string | null;
  email: string;
  displayName?: string | null;
  signupMethod: 'email' | 'apple' | 'google';
  platform: 'web';
}

const buildParams = (payload: SignupWebhookPayload) => {
  const params = new URLSearchParams();
  params.set('event', 'new_signup');
  params.set('app', 'kindred');
  params.set('platform', payload.platform);
  params.set('signup_method', payload.signupMethod);
  params.set('email', payload.email);
  params.set('display_name', payload.displayName ?? '');
  params.set('user_id', payload.userId ?? '');
  params.set('created_at', new Date().toISOString());
  return params;
};

export const notifySignupAutomation = async (payload: SignupWebhookPayload) => {
  try {
    const params = buildParams(payload);

    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      const sent = navigator.sendBeacon(SIGNUP_WEBHOOK_URL, params);
      if (sent) return;
    }

    await fetch(SIGNUP_WEBHOOK_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
      body: params.toString(),
      keepalive: true,
      mode: 'no-cors',
    });
  } catch (error) {
    console.error('Kindred signup automation webhook failed', error);
  }
};
